import React, { Component,Fragment } from 'react';
import { pageNumber } from '../../functions/functionGeneral'
import Breadcrumb from '../common/breadcrumb';
import { Loader } from 'react-loaders';
import moment from 'moment';
import 'moment/locale/id'
import {
    Table, ButtonGroup, Button, FormGroup, Input, Col, Label
} from 'reactstrap';
import { Link } from "react-router-dom";
import Paging from "../../components/paging";
import Spin from "antd/es/spin";
import "react-image-lightbox/style.css";
import {faEdit, faPlus, faRetweet, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";


export default class List_Paket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataAgenda   : [],
            paging      : 15,
            perPage     : 0,
            pageCount   : 0,
            keyword     : '',
            status      : '',
            idDel       : '',
            currentPage : 0,
            pilihBulan  : null,
            isLoading   : true,
            modalEdit   : false,
            isOpen      : false,
            visible     : false,
        }
        this.toggle                 = this.toggle.bind(this)
        this.handleChange           = this.handleChange.bind(this)
        this.handlePageClick        = this.handlePageClick.bind(this)
        this.handlePaging           = this.handlePaging.bind(this)
        this.handleSearchKeyword    = this.handleSearchKeyword.bind(this)
    }
    toggle() {
        this.setState({
            modalEdit: true
        });
    }

    handlePageClick(data) {
        let selected = data.selected;
        this.setState({currentPage: selected}, () => {
            this.loadData();
        });
    }

    refresh() {
        this.setState({
            paging      : 25,
            keyword     : "",
            status      : "",
            dataAgenda   : [],
            isLoading   : true,
        }, () => {
            this.loadData()
        })

    }

    loadData() {
        let formData = {
            auth        : this.props.auth,
            keyword     : this.state.keyword,
            status      : this.state.status,
            page        : this.state.currentPage + 1,
            paging      : this.state.paging,
        }
        this.props.request("admin/agenda/list", formData)
            .then(response => {
                if (response.success) {
                    var result = response.data.data;
                    this.setState({
                        dataAgenda   : result,
                        modal       : false,
                        auth        : this.props.auth,
                        isLoading   : false,
                    });
                }
            });
    }

    componentDidMount() {
        this.loadData()
    }

    handlePaging(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            dataAgenda   :[],
            isLoading   : true,
            [name]      : value
        }, () => {
            this.loadData()
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            currentPage : 0,
            [name]: value
        })
    }

    handleSearchKeyword(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        this.setState({
            currentPage : 0,
            keyword     : value
        })
    }

    deleteUser() {

        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin menghapus Paket Ini?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let form = {
                        agenda_id : this.state.idDel
                    }
                    this.props.request("admin/agenda/delete", form, 'POST')
                        .then(response => {
                            if (response.success) {
                                Swal.fire({
                                    title: 'Berhasil!',
                                    text: response.message,
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                })
                                this.loadData()
                            }
                        });
                }
            })
    }

    render() {
        var no = 0  ;
        return(
            <Fragment>
                <Breadcrumb title="Daftar Agenda" parent="Agenda"/>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <Link to="/agenda/add-agenda" className="btn btn-info" style={{float: "right"}}><FontAwesomeIcon icon={faPlus} style={{fontSize:12}}/> Tambah</Link>
                            <h5>Daftar Agenda</h5>
                        </div>
                        <div className="row" style={{marginLeft: '5px'}}>
                            <div className="col-3">
                                <FormGroup style={{marginLeft:11}}>
                                    <Label style={{fontSize: "8px", marginBottom: "1px"}}>Title Agenda </Label>
                                    <Input type="text"
                                           className="mb-2 form-control-sm form-control"
                                           name="keyword"
                                           onChange={this.handleSearchKeyword}
                                           onKeyUp={(event) => {
                                               event.preventDefault()

                                               if (event.which == 13) {
                                                   this.setState({
                                                       isLoading    : true,
                                                       dataAgenda    : []
                                                   }, () => {
                                                       this.loadData()
                                                   });
                                               }
                                           }}
                                           value={this.state.keyword}
                                           placeholder="Search.."/>
                                </FormGroup>
                            </div>
                            <div className="col-2">
                                {/*<FormGroup>*/}
                                {/*    <Label style={{fontSize: "8px", marginBottom: "1px"}}>(Filter Berdasarkan Status) </Label>*/}
                                {/*    <Input style={{width:'inherit',height:'32px'}} bsSize="sm" type="select" name="status" value={this.state.status} onChange={this.handlePaging}>*/}
                                {/*        <option value="">- All Status -</option>*/}
                                {/*        <option value="active">Active</option>*/}
                                {/*        <option value="non-active">Non Active</option>*/}
                                {/*    </Input>*/}
                                {/*</FormGroup>*/}
                            </div>
                            <div className="col-3">
                                <Label style={{fontSize: "8px", marginBottom: "1px"}}>(Reset Filter) </Label>
                                <div className="btn-actions-pane-right">
                                    <ButtonGroup size="sm">
                                        <Button caret="true" color="dark"
                                                className={"btn-shadow "}
                                                onClick={() => {
                                                    this.refresh();
                                                }}
                                        ><FontAwesomeIcon icon={faRetweet} style={{fontSize:12}}/> Reset</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div className="card-body">
                            <Table>
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Agenda Title</th>
                                    <th>Tanggal Agenda</th>
                                    <th>Tipe Agenda</th>
                                    <th>Agenda Note</th>
                                    <th className="text-center" width={100}>Aksi</th>
                                </tr>
                                </thead>
                                <tbody>
                                {!this.state.isLoading && this.state.dataAgenda.length === 0 ? <td colSpan={9}>Data Kosong...</td> :this.state.dataAgenda.map((item, index) => {
                                    no  += 1
                                    return(
                                        <tr key={item.agenda_id}>
                                            <th scope="row">
                                                <small>
                                                    {pageNumber(no, this.state.perPage, this.state.currentPage)}
                                                </small>
                                            </th>
                                            <td>
                                                {item.agenda_title}
                                            </td>
                                            <td>
                                                {moment(item.agenda_date).format('lll')}
                                            </td>
                                            <td>
                                                {item.agenda_type === 'liburnasional' ? 'libur nasional' : item.agenda_type === "liburperusahaan" ? 'libur perusahaan' : item.agenda_type}
                                            </td>
                                            <td>
                                                {item.agenda_note}
                                            </td>
                                            <td align={"center"}>
                                                <a href={"/agenda/edit-agenda/" + item.agenda_id}>
                                                    <FontAwesomeIcon icon={faEdit}
                                                                     style={{fontSize: 18, marginRight: 4}}/>
                                                </a>
                                                <a onClick={() => {
                                                    this.setState({
                                                        isLoading: true,
                                                        idDel: item.agenda_id
                                                    });
                                                    this.deleteUser()
                                                }}>
                                                    <FontAwesomeIcon icon={faTrash}
                                                                     style={{fontSize: 18, color: "red"}}/>
                                                </a>
                                            </td>
                                        </tr>
                                    )
                                })}
                                {this.state.isLoading &&
                                    <tr>
                                        <td colSpan="11">
                                            <Spin style={{width: '100%'}}  size="small" tip="Mohon Tunggu..."/>
                                        </td>
                                    </tr>
                                }
                                </tbody>
                            </Table>
                        </div>
                        <Paging
                            className="float-right"
                            handlePageClick={this.handlePageClick}
                            pageCount={this.state.pageCount}
                            currentPage={this.state.currentPage}
                        />

                    </div>
                </div>
            </Fragment>
        )
    }
}